/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import 'nanoscroller';
import Slider from './slider';
import Video from './video';
import Popup from './popup';

var videoObj = new Video();
new Slider();
new Popup();

$(function () {
    if ($('#video').find('.auto-video-player').hasClass('isYoutube')) {
        var checkYT = setInterval(function () {
            if (YT.loaded) {
                window.onYouTubeIframeAPIReady = videoObj.onYouTubeIframeAPIReady();
                clearInterval(checkYT);
            }
        }, 100);
    }

    $(window).on('load', () => {
        $('.preloader').fadeOut('slow');
    });


    if (window.matchMedia("(max-width: 767px)").matches) {
        // Navbar Toggle
        $('.navbar-toggle').click(function () {
            $(this).addClass('active');
            $('.mobile-navigation').addClass('active');
        });

        $('.close-nav').click(function () {
            $('.mobile-navigation').removeClass('active');
            $('.navbar-toggle').removeClass('active');
        });
    }


    $(window).on('load resize', function() {

        $('.nav-item').hover(function() {


            // Append Magic Line on current menu item
            if ($("ul#menu-main-menu .nav-item").hasClass("current-menu-item")) {
                var $thisnav = $('.current-menu-item').offset().left;
                var $left = $(this).offset().left - $thisnav;
                var $width = $(this).outerWidth();
                var $start = 0;
                $('.magic-line').css({ 'left': $left , 'width': $width });

            }
            else {
                var $thisnav = $('ul#menu-main-menu li:first-child').offset().left;
                var $left = $(this).offset().left - $thisnav;
                var $width = $(this).outerWidth();
                var $start = 0;
                $('.magic-line').css({ 'left': $left , 'width': $width, 'opacity': '1' });
            }

        }, function() {

            // Append Magic Line on current menu item
            if ($("ul#menu-main-menu .nav-item").hasClass("current-menu-item")) {
                var $initwidth = $('.current-menu-item').width();
                $('.magic-line').css({ 'left': '0' , 'width': $initwidth });
            }
            else {
                var $initwidth = $('.current-menu-item').width();
                $('.magic-line').css({ 'left': '0' , 'width': $initwidth, 'opacity': '0' });
            }

        });




    });


    // Append Magic Line on current menu item
    if ($(".nav-item").hasClass("current-menu-item")) {
        $('.nav-item.current-menu-item').append('<div class="magic-line"></div>');
    }
    else {
        $('.site-navigation ul li:first-child').append('<div class="magic-line"></div>');
    }





    // Sticky Header
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $('.theme-header').addClass("sticky");
        } else {
            $('.theme-header').removeClass("sticky");
        }
    });

    $('.modal').on('shown.bs.modal', function (e) {
        $('.slider-03').slick('setPosition');
        $('.slider-wrapper').addClass('open');
    });

    $('.card-21').mouseenter(function () {
        $(this).addClass('add');
        $(this).find('.card-21__back').addClass('add');
        $(this).find('.card-21__front').addClass('remove');
    }).mouseleave(function () {
        $(this).removeClass('add');
        $(this).find('.card-21__back').removeClass('add');
        $(this).find('.card-21__front').removeClass('remove');
    })
});
//cf7 checked boxes
$("input[name = 'checkbox-contact-form[]']").change(function () {
    if (this.checked) {
        $(this).parents('label').addClass('isActive');
        $(this).attr('checked', 'checked');
    } else {
        $(this).parents('label').removeClass('isActive');
        $(this).removeAttr('checked');
    }
});

// Logo Switcher Js
$('.switcher-btn-wrapper .btn--primary').click(function () {
    var currentActiveBtn = $('.btn-wrapper').find('.active');
    var currentActiveImage = $('.block-image-switcher figure').find('.active');
    var dataTitle = $(this).attr('data-title');

    $(this).addClass('active');
    currentActiveBtn.removeClass('active');

    currentActiveImage.removeClass('active');
    $('.block-image-switcher figure').find('.'+dataTitle).addClass('active');
});

$("#leadHikers").on('hidden.bs.modal', function (e) {
    $("#leadHikers iframe").attr("src", $("#leadHikers iframe").attr("src"));
});